import { ProgressBarProps } from './types.ts';
import { getStepperSizeConfig } from './stepper-config.ts';

export function ProgressBar({ progress, height, active = false, complete = false, stepperSize = 'md' }: ProgressBarProps) {
	const sizeConfig = getStepperSizeConfig(stepperSize);
	const barWidth = sizeConfig.progressBarWidth;
	const getFillClasses = () => {
		if (complete) {
			return "bg-success"; // Secondary color for completed steps
		}
		if (active) {
			return "bg-primary"; // Primary color for active steps
		}
		return "bg-primary"; // Primary color default
	};

	const heightValue = typeof height === "number" ? `${height}px` : height;
	const progressPercentage = Math.min(100, Math.max(0, progress));

	return (
		<div
			className="border-0"
			style={{
				width: barWidth,
				height: heightValue,
				backgroundColor: '#e9ecef', // Light grey background for inactive state
				borderRadius: Math.max(1, barWidth / 2),
				position: "relative",
				overflow: "hidden",
				marginTop: -4,
				marginBottom: -4,
				zIndex: -1,
			}}
		>
			<div
				className={getFillClasses()}
				style={{
					width: barWidth,
					height: `${progressPercentage}%`,
					borderRadius: Math.max(1, barWidth / 2),
					position: "absolute",
					top: 0,
					left: 0,
					transition: "height 0.3s ease-in-out",
				}}
			/>
		</div>
	);
}